import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { Skeleton } from "../../feedback/Skeleton";

export type BusinessInfoDisplayCardSkeletonProps = HTMLAttributes<HTMLDivElement> & {
  rows?: number;
};

const DEFAULT_BUSINESS_INFO_SKELETON_ROWS = 6;

export const BusinessInfoDisplayCardSkeleton = forwardRef<HTMLDivElement, BusinessInfoDisplayCardSkeletonProps>(
  ({ className, rows = DEFAULT_BUSINESS_INFO_SKELETON_ROWS, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("bfrs-faded-card-border bfrs-w-full bfrs-max-w-[354px] bfrs-overflow-hidden bfrs-rounded-b-[10px] bfrs-rounded-t-xl bfrs-bg-[image:var(--bfrs-gradient-business-info-card)] bfrs-shadow-card", className)}
      aria-hidden="true"
      {...props}
    >
      <div className="bfrs-flex bfrs-min-h-[174px] bfrs-flex-col bfrs-items-center bfrs-px-6 bfrs-pt-[25px] bfrs-bg-[image:var(--bfrs-gradient-business-card-header)]">
        <Skeleton animated={false} variant="avatar" className="bfrs-mb-[8px] bfrs-size-[37px] bfrs-bg-surface-card" />
        <Skeleton animated={false} variant="text" className="bfrs-h-5 bfrs-w-32 bfrs-bg-surface-card" />
        <Skeleton animated={false} variant="text" className="bfrs-mt-1 bfrs-h-4 bfrs-w-40 bfrs-bg-surface-card" />
        <div className="bfrs-mt-[18px] bfrs-flex bfrs-gap-2">
          <Skeleton animated={false} variant="text" className="bfrs-h-7 bfrs-w-[118px] bfrs-rounded-pill bfrs-bg-surface-card" />
          <Skeleton animated={false} variant="text" className="bfrs-h-7 bfrs-w-[98px] bfrs-rounded-pill bfrs-bg-surface-card" />
        </div>
      </div>
      <div className="bfrs-px-[44px] bfrs-pb-8 bfrs-pt-[8px]">
        <div className="bfrs-grid bfrs-gap-[14px]">
          {Array.from({ length: rows }, (_, index) => (
            <div key={index} className="bfrs-grid bfrs-grid-cols-[minmax(0,92px)_auto_minmax(0,1fr)] bfrs-items-center bfrs-gap-x-6">
              <Skeleton animated={false} variant="text" className="bfrs-h-4 bfrs-w-full" />
              <Skeleton animated={false} variant="text" className="bfrs-h-4 bfrs-w-1" />
              <Skeleton animated={false} variant="text" className="bfrs-h-4 bfrs-w-24" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
);

BusinessInfoDisplayCardSkeleton.displayName = "BusinessInfoDisplayCardSkeleton";
